import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  INIT_URL,
  USER_DATA,
  USER_TOKEN_SET
} from "../../constants/ActionTypes";
import RequestHandler from "../../util/RequestHandler";

export const setInitUrl = (url) => {
  return {
    type: INIT_URL,
    payload: url
  };
};

export const userSignUp = ({ email, password, name }) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    RequestHandler.post('auth/register', {
      email: email,
      password: password,
      name: name
    }
    ).then(({ data }) => {
      if (data.result) {
        dispatch({ type: FETCH_SUCCESS });
        dispatch({ type: USER_TOKEN_SET, payload: data.token.access_token });
        dispatch({ type: USER_DATA, payload: data.user });
      } else {
        dispatch({ type: FETCH_ERROR, payload: "Network Error" });
      }
    }).catch(function (error) {
      dispatch({ type: FETCH_ERROR, payload: error.message });
    });
  }
};

export const userSignIn = ({ email, password }) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    RequestHandler.post(`/Auth/Login`, {
      email: email,
      password: password,
    }).then((response) => {
      if (response.success) {
        RequestHandler.setUserInfo(response);
        dispatch({ type: FETCH_SUCCESS });
        window.location.reload();
      } else {
        dispatch({ type: FETCH_ERROR, payload: response.message });
      }
    });
  }
};

export const getUser = () => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    RequestHandler.post('auth/me',
    ).then(({ data }) => {
      if (data.result) {
        dispatch({ type: FETCH_SUCCESS });
        dispatch({ type: USER_DATA, payload: data.user });
      } else {
        dispatch({ type: FETCH_ERROR, payload: data.error });
      }
    }).catch(function (error) {
      dispatch({ type: FETCH_ERROR, payload: error.message });
    });
  }
};

export const userSignOut = (value) => {
  RequestHandler.get(`/Auth/Logout?userId=${value}`).then(response => {
    if (response.success) {
      RequestHandler.removeUserInfo();
      window.location.reload();
    }
  });
};

